import { Icon, IconProps } from '@chakra-ui/react'

export default function AutomationCircleIcon(props: IconProps) {
  return (
    <Icon
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#868E96'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7369 9.56497L13.1995 10.4549L8.7673 14.9008L9.2595 11.7883L6.79688 10.8991L11.2291 6.89746L10.7369 9.56497Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="2.79492"
        y="3.69629"
        width="14.406"
        height="14.406"
        rx="7.203"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
